// react-native-gesture-handler resolves to its CommonJS build on web, where
// GestureHandlerRootView renders the NATIVE component → our codegen null-stub →
// it renders nothing, dropping the whole app subtree (Main wraps everything in
// it). Keep the real module (gesture detectors etc. that react-navigation needs)
// but override GestureHandlerRootView to a plain web View that renders children.
const React = require("react");
const { View } = require("react-native"); // → react-native-web
const real = require("react-native-gesture-handler/lib/commonjs/index.js");

function GestureHandlerRootView(props) {
  const { children, style, ...rest } = props || {};
  return React.createElement(View, { style: style || { flex: 1 }, ...rest }, children);
}

// gesture-handler ships its OWN TouchableNativeFeedback (separate from RN's),
// also missing the Android-only Ripple/SelectableBackground statics. Screens
// like UpcomingDeliveryReturn call TouchableNativeFeedback.Ripple(...) → crash.
// Patch the singleton (mirrors the RN one patched in web/app.js).
const TNF = real.TouchableNativeFeedback;
if (TNF) {
  if (typeof TNF.Ripple !== "function")
    TNF.Ripple = (color, borderless) => ({ type: "RippleAndroid", color, borderless });
  if (typeof TNF.SelectableBackground !== "function")
    TNF.SelectableBackground = (r) => ({ type: "ThemeAttrAndroid", attribute: "selectableItemBackground", rippleRadius: r });
  if (typeof TNF.SelectableBackgroundBorderless !== "function")
    TNF.SelectableBackgroundBorderless = (r) => ({ type: "ThemeAttrAndroid", attribute: "selectableItemBackgroundBorderless", rippleRadius: r });
  if (typeof TNF.canUseNativeForeground !== "function")
    TNF.canUseNativeForeground = () => false;
}

module.exports = Object.assign({}, real, {
  __esModule: true,
  GestureHandlerRootView,
  default: real.default,
});
